// add a new path here
export const BREADCRUMB_NAMES = {
  "dashboard": 'Dashboard',
  "reports": "Reports",
  "user-role-management": "User Role Management",
  "configuration": 'Configuration',
  "practices": 'Practices',
  "pms-objects": 'PMS Objects',
  "pms-schema-integrity": 'PMS Schema Integrity',
  "phi-records": 'PHI Records',
  "pms": 'PMS',
  "load-schedules": 'Load Schedules',
  "practice-load-configurations": "Practice Load Configurations",
  "profile": "Profile",
  "pms-agent-health-status": "PMS Agent Health Status",
  "practice-load-summary": "Practice Load Summary",
  "details": "Details",
  "practice-installation-logs": "Practice Installation Log",
  "configure": "Configure",
  "manage-agent-releases": "Manage Agent Releases",
  "assign": "Assign",
  "practice-error-logs": "Practice Error Logs",
  "user-logs": "User Logs",
  "audit-report": "Audit Report",
  "audit-report-new": "Audit Report New",
  "daily-load-volume-trend": "Daily Load Volume Trend",
  "pms-agent-heartbeats": "PMS Agent Heartbeats",
  "forbidden": "Forbidden",
  "last-seven-days-load": "Last 7 Days Data Load",
  "practice-operational-hours": "Practice Operational Hours",
  "dentrix-adjustment-types": "Dentrix Adjustment Type",
  "net-production-report": "Net Production Report",
  "net-collection-report": "Net Collection Report",
  "backup-monitor": "Backup Monitor"
};



